module.exports = __webpack_public_path__ + "static/media/YB5M16_6.29acd2f9.jpg";